<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <div v-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        class="mt-2"
        label="Título da lista *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        class="mt-2"
        label="Descrição da lista"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <v-select
      v-model="nodeDataLocale.tipoAgendamentoId"
      class="mt-2"
      outlined
      clearable
      label="Selecione um tipo de agendamento"
      item-text="nome"
      item-value="id"
      no-data-text="Nenhuma tipo de agendamento encontrado"
      :items="tipoAgendamentos"
      @change="nodeConfig"
    />

    <v-select
      v-model="nodeDataLocale.agenteId"
      class="mt-2"
      outlined
      clearable
      label="Agente externo"
      item-text="nome"
      item-value="id"
      no-data-text="Nenhum agente disponível"
      :items="agentesExternos"
    />

    <v-row>
      <v-col cols="auto">
        <v-checkbox
          v-model="nodeDataLocale.agenteDisponibilidadePeriodoDiaId"
          :value="1"
          label="Manhã"
          @change="nodeConfig"
        />
      </v-col>

      <v-col cols="auto">
        <v-checkbox
          v-model="nodeDataLocale.agenteDisponibilidadePeriodoDiaId"
          :value="2"
          label="Tarde"
          @change="nodeConfig"
        />
      </v-col>

      <v-col cols="auto">
        <v-checkbox
          v-model="nodeDataLocale.agenteDisponibilidadePeriodoDiaId"
          :value="3"
          label="Noite"
          @change="nodeConfig"
        />
      </v-col>
    </v-row>

    <v-select
      v-model="nodeDataLocale.agenteDisponibilidadeId"
      class="mt-2"
      outlined
      clearable
      label="Disponibilidades do Agente"
      item-value="id"
      item-text="dataFormatada"
      no-data-text="Nenhuma disponibilidade encontrada para o agente"
      :items="agenteDisponibilidades"
      @change="nodeConfig"
    />

    <!-- <div v-if="agenteDisponibilidades.length > 0">
      <h2>Disponibilidade do Agente</h2>
      <ul>
        <li
          v-for="disponibilidade in agenteDisponibilidades"
          :key="disponibilidade.id"
        >
          {{ disponibilidade.diaSemanaNome }} - {{ disponibilidade.data }} - {{ disponibilidade.horaFinal }}
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { ref, watch, inject } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import TicketAgendamentoTipoService from '@/services/modules/TicketAgendamentoTipoService'
import EquipeService from '@/services/modules/EquipeService'
import AgenteService from '@/services/modules/AgenteService'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'

export default {
  setup(_, { emit }) {
    const tipoAgendamentos = ref([])
    const agentesExternos = ref([])
    const agenteDisponibilidades = ref([])

    const opcoes = ref([])

    function exibirOpcoesDoNo(data) {
      let concat = ''
      if (data.chatBotNoTipoId === 1) {
        if (data.nosFilhos.length > 0) {
          data.nosFilhos.forEach(element => {
            concat += `${element.numero} - ${element.texto}\n`
          })
        }
      }
      opcoes.value = concat
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')

    watch(
      () => nodeData.value,
      value => {
        nodeDataLocale.value = value
        exibirOpcoesDoNo(value)
      },
      { immediate: true, deep: true },
    )

    async function loadTipoAgendamentos() {
      try {
        tipoAgendamentos.value = await TicketAgendamentoTipoService.get()
      } catch (error) {
        console.error('Erro ao carregar tipo de agendamentos:', error)
      }
    }

    async function loadAgentesExternos() {
      try {
        agentesExternos.value = await EquipeService.getEquipesAgentesExternos()
      } catch (error) {
        console.error('Erro ao carregar tipo de agendamentos:', error)
      }
    }

    async function loadAgenteDisponibilidades() {
      if (!nodeDataLocale.value.agenteId) return

      try {
        agenteDisponibilidades.value = await AgenteService.getDisponibilidades(nodeDataLocale.value.agenteId)
      } catch (error) {
        console.error('Erro ao carregar a diponibilidade do agente:', error)
      }
    }

    loadTipoAgendamentos()
    loadAgentesExternos()
    loadAgenteDisponibilidades()

    watch(
      () => nodeDataLocale.value.agenteId,
      loadAgenteDisponibilidades,
      { immediate: true },
    )

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')

    watch(
      () => tipoIdPai.value,
      value => {
        tipoIdPaiLocale.value = value
      },
      { immediate: true, deep: true },
    )

    function nodeConfig() {
      emit('node-config')
    }

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,

      tipoAgendamentos,
      agentesExternos,
      agenteDisponibilidades,

      opcoes,

      validators: {
        required,
        select,
      },
    }
  },
}
</script>
